export enum PaymentErrorType {
  CARD_DECLINED = 'CARD_DECLINED',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  CUSTOMER_NOT_FOUND = 'CUSTOMER_NOT_FOUND',
  SUBSCRIPTION_NOT_FOUND = 'SUBSCRIPTION_NOT_FOUND',
  NETWORK_ERROR = 'NETWORK_ERROR',
  CONFIGURATION_ERROR = 'CONFIGURATION_ERROR',
  WEBHOOK_ERROR = 'WEBHOOK_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  PROVIDER_NOT_CONFIGURED = 'PROVIDER_NOT_CONFIGURED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  INITIALIZATION_ERROR = 'INITIALIZATION_ERROR',
  AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',
  NOT_FOUND = 'NOT_FOUND',
  INVALID_REQUEST = 'INVALID_REQUEST',
  API_ERROR = 'API_ERROR',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  WEBHOOK_VERIFICATION_FAILED = 'WEBHOOK_VERIFICATION_FAILED',
}

export interface PaymentError extends Error {
  type: PaymentErrorType;
  code?: string;
  details?: Record<string, unknown>;
}

export class PaymentsError extends Error implements PaymentError {
  public type: PaymentErrorType;
  public code?: string;
  public details?: Record<string, unknown>;

  constructor(
    type: PaymentErrorType,
    message: string,
    code?: string,
    details?: Record<string, unknown>
  ) {
    super(message);
    this.name = 'PaymentsError';
    this.type = type;
    this.code = code;
    this.details = details;
    Object.setPrototypeOf(this, PaymentsError.prototype);
  }
}
